import React, { Fragment, PureComponent } from 'react';
import EventListener from 'react-event-listener';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Menu = styled.div`
  font-family: 'Pluto Sans SemiBold', sans-serif;
  font-size: 18px;
  display: flex;
  justify-content: space-around;
  pointer-events: all;
  width: 320px;
  margin: auto;
`;

const Indicator = styled.div.attrs(({ left, width }) => ({
  style: {
    left: left,
    width: width,
  },
}))`
  background-color: rgba(0, 0, 0, 0);
  bottom: 0;
  height: 0px;
  position: absolute;
  transition: none 0.2s ease-out;
  transition-property: ${(props) => props.animate && 'left, width'};
`;

class Tabs extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { animate: false, loaded: false };
    this.tabsRef = null;
  }

  componentDidMount() {
    this.onResize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.onResize(null, true);
    }
  }

  onLoad = () => {
    this.setState({ loaded: true });
    this.onResize();
  };

  onResize = (e, animate = false) => {
    let selectedIndex = -1;
    if (this.props.value in this.valueToIndex) {
      selectedIndex = this.valueToIndex[this.props.value];
    }

    if (selectedIndex >= 0) {
      const { tabsRef } = this;
      const { left, width } = tabsRef.children[0].children[selectedIndex].getBoundingClientRect();

      this.setState({ animate, left, width });
    }
  };

  render() {
    const { loaded, ...indicatorStyle } = this.state;

    this.valueToIndex = {};
    let childIndex = 0;
    const children = React.Children.map(this.props.children, (child) => {
      if (!React.isValidElement(child)) {
        return null;
      }

      const childValue = child.props.value;
      this.valueToIndex[childValue] = childIndex;

      childIndex += 1;
      return React.cloneElement(child, {
        onChange: this.onChange,
        selected: childValue === this.props.value,
      });
    });

    return (
      <Fragment>
        <EventListener target="window" onResize={this.onResize} onLoad={this.onLoad} />
        <div
          ref={(e) => {
            this.tabsRef = e;
          }}
        >
          <Menu>{children}</Menu>
        </div>
        {loaded && <Indicator {...indicatorStyle} />}
      </Fragment>
    );
  }
}

export { Tabs };
